/**
 * Available Markup for Stepper Step Component
 */
export var StepMarkup;
(function (StepMarkup) {
    StepMarkup["P"] = "p";
    StepMarkup["SPAN"] = "span";
    StepMarkup["DIV"] = "div";
    StepMarkup["A"] = "a";
})(StepMarkup || (StepMarkup = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RlcEVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9jb21wb25lbnRzL3N0ZXBwZXIvc3RlcC9TdGVwRW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFVBS1g7QUFMRCxXQUFZLFVBQVU7SUFDcEIscUJBQU8sQ0FBQTtJQUNQLDJCQUFhLENBQUE7SUFDYix5QkFBVyxDQUFBO0lBQ1gscUJBQU8sQ0FBQTtBQUNULENBQUMsRUFMVyxVQUFVLEtBQVYsVUFBVSxRQUtyQiJ9